import { typeKind } from '@Common/Enums/Enum';

export const inputType = {
    string: typeKind.string,
    bool: typeKind.bool,
    guid: typeKind.guid,
    dateTime: typeKind.dateTime,
    float: typeKind.float,
    int: typeKind.int,
    text: typeKind.text,
    url: 'url',
    timeSpan: 'timeSpan'
};
